export class Helper {
    public static isNextStep:boolean;
    public static isHideLoader: boolean=false;
    public static previousURL:string;
}
